/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoImagenCropLista from "../../Modulo_formularios/Componentes/IngresoImagenCropLista";


const Formulario_Pasarela = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Imagenes fondo transparente</Typography>
                </Grid>


                <Grid container size={12}>
                    <IngresoImagenCropLista alto={2} ancho={1}
                                            dato={'imgs'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Pasarela